import React, { ReactNode } from 'react';

export interface TbcSimpleBreakdownColumn<T> {
    key: string;
    header: ReactNode;
    render: (row: T) => ReactNode;
    headerClassName?: string;
}

interface TbcSimpleBreakdownTableProps<T> {
    rows: T[];
    columns: TbcSimpleBreakdownColumn<T>[];
    rowKey: (row: T) => string;
    emptyMessage?: string;
    onRowClick?: (row: T) => void;
    expandedRowKey?: string | null;
    renderExpandedRow?: (row: T) => ReactNode;
    expandedColSpan?: number;
}

function TbcSimpleBreakdownTable<T>({
    rows,
    columns,
    rowKey,
    emptyMessage = 'No rows to display.',
    onRowClick,
    expandedRowKey = null,
    renderExpandedRow,
    expandedColSpan,
}: TbcSimpleBreakdownTableProps<T>) {
    const colSpan = expandedColSpan ?? columns.length;

    return (
        <div className="table-container" style={{ overflowX: 'auto' }}>
            <table className="breakdown-table">
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key} className={column.headerClassName}>
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.length === 0 && (
                        <tr>
                            <td colSpan={columns.length}>{emptyMessage}</td>
                        </tr>
                    )}
                    {rows.map((row) => {
                        const key = rowKey(row);
                        return (
                            <React.Fragment key={key}>
                                <tr
                                    onClick={onRowClick ? () => onRowClick(row) : undefined}
                                    style={onRowClick ? { cursor: 'pointer' } : undefined}
                                >
                                    {columns.map((column) => (
                                        <td key={column.key}>{column.render(row)}</td>
                                    ))}
                                </tr>
                                {expandedRowKey === key && renderExpandedRow && (
                                    <tr>
                                        <td colSpan={colSpan} style={{ padding: 0 }}>
                                            {renderExpandedRow(row)}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default TbcSimpleBreakdownTable;
